const POST_DOCUMENT = "POST_QUESTION"
const POST_DOCUMENT_SUCCESS = "POST_DOCUMENT_SUCCESS"
const POST_DOCUMENT_FAIL = "POST_DOCUMENT_FAIL"

const BASE_ENDPOINT = '/Document/';
const initialValues = {

  loading: false,
  hasError: false,
  questions: [],
};

const document = (state = initialValues, action) => {

  switch (action.type) {

    case POST_DOCUMENT: {

      return {
        ...state,
        loading: true,

      }

    }


    case POST_DOCUMENT_SUCCESS: {

      return {
        ...state,
        loading: false,
      }

    }

    case POST_DOCUMENT_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }


    default: {
      return state;
    }

  }
};

export const postSendDocument = (data, dtId) => {
      
  let url = '';
  switch (dtId) {
    case 2:
      url = 'AdvancePayment/'
      break;
    case 4:
      url = 'DebitNote/'
      break;
    case 5:
      url = 'CreditNote/'
      break;
    case 8:
        url = 'Invoice/'
        break;
    case 1:
      url = 'Invoice/'
      break;
  
    default:
      break;
  }
  return {
    type: POST_DOCUMENT,
    payload: {
      request: {
        method: 'POST',
        url: BASE_ENDPOINT + url,
        data: data,
        headers: {
          contentType: "multipart/form-data"
        }
      }
    }
  }
};

export default document;
